<template>
  <div>
    <BookingDetailsPanel ref="BookingDetails" printTitle="Appointment Summary">
    </BookingDetailsPanel>
    <p class="mt-4">
      Please arrive early to complete required forms. You may not check-in more than
       {{earlyMinutesSetting}} minutes prior to your appointment.
    </p>
    <p>If you are more than {{lateMinutesSetting}} minutes late,
       your appointment will be cancelled.</p>
    <div class="text-center mx-auto btn-container">
      <v-layout row wrap>
        <v-flex sm="4" class="pa-1">
          <v-btn class="ma-2" color="primary" @click="print()"
          ><v-icon>mdi-printer</v-icon>
          PRINT
        </v-btn>
        </v-flex>
        <v-flex sm="4" class="pa-1">
          <v-btn class="ma-2"
            color="primary"
            @click="nextPage('CancelAppointmentPage')"
          ><v-icon>mdi-cancel</v-icon>
          CANCEL APPOINTMENT
        </v-btn>
        </v-flex>
        <v-flex sm="4" class="pa-1">
          <v-btn class="ma-2" color="primary" @click="nextClick()"
          ><v-icon>mdi-calendar-month</v-icon>
          RESCHEDULE APPOINTMENT
        </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm="6" class="pa-1">
          <v-btn class="ma-2" color="primary" @click="nextPage('LandingPage')"
          ><v-icon>mdi-arrow-left</v-icon>
          PREVIOUS
        </v-btn></v-flex>
        <v-flex sm="6" class="pa-1">
          <v-btn class="ma-2" color="primary" @click="exitClick()"
          ><v-icon>mdi-exit-run</v-icon>EXIT
        </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import BookingDetailsPanel from '@/components/BookingDetailsPanel.vue';
import { mapGetters, mapActions } from 'vuex';
import SessionState from '../models/SessionState';

export default {
  components: {
    BookingDetailsPanel,
  },
  methods: {
    ...mapActions('bookingDetails', ['rescheduleBooking']),
    ...mapActions({ isLogInAction: 'isLogIn' }),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    nextClick() {
      console.log('rescheduleBooking');
      this.rescheduleBooking({ value: true });
      this.$emit('navigateTo', 'CustomerDetailsPage');
    },
    print() {
      console.log('Inside print of ViewExistingPage');
      this.$refs.BookingDetails.Printer();
    },
    exitClick() {
      this.isLogInAction({ value: false });
      SessionState.ClearSession();
      this.$emit('navigateTo', 'LoginPage');
    },
  },
  computed: {
    ...mapGetters(['earlyMinutes', 'lateMinutes']),
    earlyMinutesSetting() {
      return this.earlyMinutes !== 0
        ? this.earlyMinutes
        : 30;
    },
    lateMinutesSetting() {
      return this.lateMinutes !== 0
        ? this.lateMinutes * (-1)
        : 10;
    },
  },
};
</script>

<style scoped>

</style>
